<template>
  <div class="py-6">
    <v-container fluid class="pt-0">
      <div class="d-flex align-center mb-6">
        <h5 class="font-weight-bold text-h5 text-typo mb-0">異常管理</h5>
        <v-spacer></v-spacer>
        <!-- Optional: Company Select if not handled globally -->
      </div>

      <v-card class="card-shadow border-radius-xl">
        <v-tabs
          v-model="activeTab"
          background-color="transparent"
          color="primary"
          class="px-4 pt-4"
        >
          <v-tab class="text-capitalize font-weight-bold">
            <v-icon left size="20" color="orange"
              >mdi-clock-alert-outline</v-icon
            >
            打卡異常
          </v-tab>
          <v-tab class="text-capitalize font-weight-bold">
            <v-icon left size="20" color="blue"
              >mdi-file-document-edit-outline</v-icon
            >
            銷假
          </v-tab>
          <v-tab class="text-capitalize font-weight-bold">
            <v-icon left size="20" color="red"
              >mdi-alert-octagon-outline</v-icon
            >
            出勤異常
          </v-tab>
        </v-tabs>

        <v-divider></v-divider>

        <v-tabs-items v-model="activeTab" class="bg-transparent">
          <!-- Clock-in Anomaly Tab -->
          <v-tab-item>
            <v-card flat>
              <v-card-text class="pa-0">
                <clock-anomaly-widget
                  :selected-company="selectedCompany"
                  :can-edit="canEditRole"
                />
              </v-card-text>
            </v-card>
          </v-tab-item>

          <!-- Leave Cancellation (Attachment Required) Tab -->
          <v-tab-item>
            <v-card flat>
              <v-card-text class="pa-0">
                <attachment-required-widget
                  ref="attachmentRequiredWidget"
                  :selected-company="selectedCompany"
                  :can-edit="canEditRole"
                  @error="handleWidgetError"
                />
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-card-text class="pa-0">
                <absent-days-widget
                  :selected-company="selectedCompany"
                  :can-edit="canEditRole"
                />
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>

      <!-- Info Dialog for error messages -->
      <info-dialog
        :visible.sync="showInfoDialog"
        :title="infoDialogTitle"
        :message="infoDialogMessage"
        yes-button-text="確定"
      />
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import InfoDialog from "@/components/Common/InfoDialog.vue";
import AttachmentRequiredWidget from "@/components/Widgets/AttachmentRequiredWidget.vue";
import ClockAnomalyWidget from "@/components/Widgets/ClockAnomalyWidget.vue";
import AbsentDaysWidget from "@/components/Widgets/AbsentDaysWidget.vue";

export default {
  name: "AnomalyManagement",
  components: {
    InfoDialog,
    AttachmentRequiredWidget,
    ClockAnomalyWidget,
    AbsentDaysWidget,
  },
  data() {
    return {
      activeTab: 0,
      showInfoDialog: false,
      infoDialogTitle: "",
      infoDialogMessage: "",
    };
  },
  computed: {
    ...mapGetters("company", ["selectedCompany"]),
    ...mapGetters("user", ["canEditRole"]),
  },
  watch: {
    activeTab(newVal) {
      if (newVal === 1) {
        this.$nextTick(() => {
          this.$refs.attachmentRequiredWidget?.fetchAttachmentRequired();
        });
      }
    },
    selectedCompany() {
      if (this.activeTab === 1) {
        this.$refs.attachmentRequiredWidget?.fetchAttachmentRequired();
      }
    },
  },
  methods: {
    handleWidgetError({ title, message }) {
      this.infoDialogTitle = title;
      this.infoDialogMessage = message;
      this.showInfoDialog = true;
    },
  },
};
</script>

<style scoped>
.v-tabs-items {
  min-height: 400px;
}
</style>
